import { PaginationNumberLinkContext } from "ngx-bootstrap/pagination";
import { impuesto } from "./impu";

export class cajaDetalle {
   id:number;
   modedaUno:number;
   modela5:number;
   moneda10:number;
   moneda25:number;
   moneda50:number
   moneda_centavo:number;
   idCaja:number;
   valorUnDolar:number;
   valorDolar5:number;
   valorDolar10:number;
   valorDolar20:number;
   valorDolar50:number;
   valorDolar100:number;

}
